import React from 'react';
import TranscriptionDetail from '../TranscriptionDetail';

/** Court Admin transcription detail — same review/certify UI under /admin. */
const AdminTranscriptionDetail = () => <TranscriptionDetail />;

export default AdminTranscriptionDetail;
